require('angular')
HdcpService = require('./hdcp-service')
hdcpToLabel = require('./hdcp-to-label-filter')

angular.module 'gnp-hdcp', []
  .factory 'HdcpService', HdcpService
  .filter 'hdcpToLabel', hdcpToLabel





// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/hdcp/hdcp-module.coffee